import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {seniorAdd} from "../../../api/seniorApi";
import {useFormValidation} from "../../../hooks/useFormValidation";
import {useIosKeyboardOffset} from "../../../hooks/useIosKeyboardOffset";
import {useIosInputAutoScroll} from "../../../hooks/useIosInputAutoScroll";
import {defaultAlert} from "../../../utils/alert";

export default function SeniorAddPage() {
    const navigate = useNavigate();
    const {validateSeniorFormPage} = useFormValidation();

    const keyboardHeight = useIosKeyboardOffset();
    useIosInputAutoScroll();

    const [formData, setFormData] = useState({
        name: '',
        birthday: '',
        gender: '',
        weight: '',
        height: '',
        longTermCareInsuranceNumber: '',
        relationship: ''
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const {name, value} = e.target;
        let sanitized = value;
        if (name === 'height' || name === 'weight') {
            const num = value.replace(/[^0-9]/g, '');
            sanitized = num === '' ? '' : String(parseInt(num, 10));
        }
        setFormData(prev => ({
            ...prev,
            [name]: sanitized
        }));
    };

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (!validateSeniorFormPage(formData)) {
            return;
        }


        try {
            await seniorAdd(formData);
            navigate('/menu/seniorList');
        } catch (error) {
            console.error(error);
            defaultAlert('어르신 등록에 실패했습니다.');
        }
    };
    return (
        <>
            <div
                className="bottom-btn"
                style={keyboardHeight > 0 ? {display: 'none'} : undefined}
            >
                <button
                    id=""
                    type="button"
                    className="btn confirm"
                    onClick={handleSubmit}
                >
                    등록
                </button>
            </div>
            {/*//bottom-btn*/}
            {/* container*/}
            <main className="container type_gray">
                <div className="form-box">
                    <section>
                        <fieldset>
                            <legend>어르신 정보 폼</legend>
                            <div className="inner-box">
                                <div className="round-box">
                                    <div className="round-header">
                                        <h3 className="round-tit">어르신 정보</h3>
                                    </div>
                                    <div className="round-body">
                                        <div className="form-item">
                                            <label htmlFor="name" className="input-tit">어르신 이름</label>
                                            <div className="line-input-box">
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    className="text-right"
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                    placeholder="어르신 이름을 입력해주세요"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="birthday" className="input-tit">생년월일 <span
                                                className="point">*</span></label>
                                            <div className="line-input-box">
                                                <input
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    type="text"
                                                    id="birthday"
                                                    name="birthday"
                                                    className="text-right"
                                                    value={formData.birthday}
                                                    onChange={handleInputChange}
                                                    placeholder="어르신의 생년월일을 입력해주세요.(yyyyMMdd)"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="gender" className="input-tit">성별</label>
                                            <div className="line-input-box">
                                                <select
                                                    id="gender"
                                                    name="gender"
                                                    value={formData.gender}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="" hidden>선택</option>
                                                    <option value="M">남성</option>
                                                    <option value="F">여성</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="height" className="input-tit">키(cm)</label>
                                            <div className="line-input-box">
                                                <input
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    type="text"
                                                    id="height"
                                                    name="height"
                                                    className="text-right"
                                                    value={formData.height}
                                                    onChange={handleInputChange}
                                                    placeholder="어르신의 키를 입력해주세요"
                                                />
                                                <span>cm</span>
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="weight" className="input-tit">체중(Kg)</label>
                                            <div className="line-input-box">
                                                <input
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    type="text"
                                                    id="weight"
                                                    name="weight"
                                                    className="text-right"
                                                    value={formData.weight}
                                                    onChange={handleInputChange}
                                                    placeholder="어르신의 체중을 입력해주세요"
                                                />
                                                <span>kg</span>
                                            </div>
                                        </div>

                                        <div className="form-item">
                                            <label htmlFor="longTermCareInsuranceNumber" className="input-tit">장기요양보험 가입번호</label>
                                            <div className="line-input-box">
                                                <input
                                                    type="text"
                                                    id="longTermCareInsuranceNumber"
                                                    name="longTermCareInsuranceNumber"
                                                    className="text-right"
                                                    value={formData.longTermCareInsuranceNumber}
                                                    onChange={handleInputChange}
                                                    placeholder="어르신의 보험번호를 입력해주세요"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="relationship" className="input-tit">관계</label>
                                            <div className="line-input-box">
                                                <select
                                                    id="relationship"
                                                    name="relationship"
                                                    value={formData.relationship}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="" hidden>선택</option>
                                                    <option value="SPOUSE">배우자</option>
                                                    <option value="PARENT">부모</option>
                                                    <option value="CHILD">자녀</option>
                                                    <option value="SIBLING">형제자매</option>
                                                    <option value="COUSIN">친척</option>
                                                    <option value="OTHER">기타</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </section>
                </div>
            </main>
        </>
    );
}